// extracted by mini-css-extract-plugin
export default {"contenedorBotonGrabar":"PosicionesTorneo_contenedorBotonGrabar__+6gIy","botonGrabar":"PosicionesTorneo_botonGrabar__SO294"};